import ChannelInfo from "discourse/plugins/chat/discourse/components/chat/routes/channel-info";

export default <template>
  <ChannelInfo @channel={{@controller.model}} />
</template>
